module.exports = __webpack_public_path__ + "static/media/placeholder.c57d7605.png";